import { createPortal } from "react-dom"


let AdModal = ({ setClick, imageSource, adID }) => {
    let handleClick = () => {
        setClick()
    }

    return     createPortal(
        <>
          <div className="adModal">
            <button className="adModal-close" onClick={() => { handleClick() }}>×</button>
            <img onClick={() => { handleClick() }} alt={adID} src={imageSource} />
        </div>
        </>,
        document.getElementById('root-modal')
      )
}
export default AdModal;